import React, { useState, useImperativeHandle } from "react";
import { View, Text, Modal, StyleSheet } from "react-native";
import { useSelector } from "react-redux";

import { colors } from "@constants/theme";
import PressableButton from "@components/PrimaryButton";
import t from "@constants/localization";

const PATH = "screens/Vacation/components/WarningModal";

const WarningModal = React.forwardRef(({ onMarkVacation }, ref) => {
  const { vacation_dates_spent, commissioned_leaves_remaining } = useSelector(
    (state) => state.vacation,
  );
  const [showModal, setShowModal] = useState(false);
  const freeVacationsLimitExceeded =
    vacation_dates_spent.length >= 12 && commissioned_leaves_remaining === 0;

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleHideModal = () => {
    setShowModal(false);
  };

  useImperativeHandle(ref, () => ({
    showModal() {
      handleShowModal();
    },
  }));

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={handleHideModal}
    >
      <View style={styles.modalWrapper}>
        {freeVacationsLimitExceeded ? (
          <View style={styles.container}>
            <Text style={styles.title}>{t(`${PATH}/title`)}</Text>
            <Text style={styles.description}>{t(`${PATH}/description`)}</Text>
            <View style={styles.buttonContainer}>
              <PressableButton
                text={t(`${PATH}/cancel`)}
                buttonStyle={styles.button}
                textStyle={styles.cancelBtnText}
                buttonColor={colors.white}
                onPress={() => {
                  setShowModal(false);
                }}
              />
              <PressableButton
                text={t(`${PATH}/markLeave`)}
                buttonStyle={styles.button}
                textStyle={styles.markLeaveBtnText}
                buttonColor={colors.white}
                onPress={() => {
                  setShowModal(false);
                  onMarkVacation();
                }}
              />
            </View>
          </View>
        ) : (
          <View style={styles.container}>
            <Text style={styles.title}>{t(`${PATH}/title2`)}</Text>
            <Text style={styles.description}>{t(`${PATH}/description2`)}</Text>
            <View style={styles.buttonContainer}>
              <PressableButton
                text={t(`${PATH}/edit`)}
                buttonStyle={styles.button}
                textStyle={styles.cancelBtnText}
                buttonColor={colors.white}
                onPress={() => {
                  setShowModal(false);
                  onMarkVacation();
                }}
              />
              <PressableButton
                text={t(`${PATH}/okay`)}
                buttonStyle={styles.button}
                textStyle={styles.markLeaveBtnText}
                buttonColor={colors.white}
                onPress={() => {
                  setShowModal(false);
                }}
              />
            </View>
          </View>
        )}
      </View>
    </Modal>
  );
});

const styles = StyleSheet.create({
  modalWrapper: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: colors.lightBlack,
  },
  container: {
    backgroundColor: "white",
    paddingVertical: 24,
    width: "90%",
    borderRadius: 6,
  },
  title: {
    fontFamily: "NotoSansDevanagari-Bold",
    fontSize: 20,
    fontWeight: "700",
    lineHeight: 30,
    textAlign: "left",
    paddingHorizontal: 40,
  },
  description: {
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 14,
    fontWeight: "400",
    lineHeight: 20,
    textAlign: "left",
    marginVertical: 16,
    paddingHorizontal: 40,
  },
  buttonContainer: {
    alignItems: "center",
    marginTop: 10,
    width: "100%",
    paddingHorizontal: 10,
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  button: {
    paddingVertical: 6,
    marginHorizontal: 4,
    minWidth: "25%",
    paddingHorizontal: 0,
    borderRadius: 6,
    alignSelf: "flex-end",
  },
  markLeaveBtnText: {
    fontFamily: "NotoSansDevanagari-Bold",
    fontSize: 14,
    color: colors.primary,
  },
  cancelBtnText: {
    fontFamily: "NotoSansDevanagari-SemiBold",
    color: colors.lightBlack,
    fontSize: 16,
  },
});

export default WarningModal;
